export enum RewriterToneEnum {
  MoreFormal = 'more-formal',
  AsIs = 'as-is',
  MoreCasual = 'more-casual',
}
